var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 41,
    viewBox: "0 0 141 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_2593)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.155 0H5.67085C2.53893 0 0 2.50314 0 5.59091V35.4091C0 38.4969 2.53893 41 5.67085 41H135.155C138.287 41 140.826 38.4969 140.826 35.4091V5.59091C140.826 2.50314 138.287 0 135.155 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0365 10.2503C78.0365 12.1029 76.5101 13.6049 74.6271 13.6049C72.7441 13.6049 71.2177 12.1029 71.2177 10.2503C71.2177 8.39764 72.7441 6.89575 74.6271 6.89575C76.5101 6.89575 78.0365 8.39764 78.0365 10.2503ZM76.9947 10.2503C76.9947 11.5369 75.9347 12.5799 74.6271 12.5799C73.3195 12.5799 72.2595 11.5369 72.2595 10.2503C72.2595 8.96373 73.3195 7.92075 74.6271 7.92075C75.9347 7.92075 76.9947 8.96373 76.9947 10.2503Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2646 7.17529H50.4764V7.26847V7.92075V9.87757V10.623V12.673V13.4185H51.5182H54.2646V12.673H51.5182V10.623H53.9805V9.87757H51.5182V7.92075H54.2646V7.17529Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9161 7.1748H55.3061V7.92026H56.9161V13.418H57.9578V7.92026H59.5679V7.1748H57.9578H56.9161Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1988 7.17529H64.5889V7.92075H66.1988V13.4185H67.2406V7.92075H68.8506V7.17529H67.2406H66.1988Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.642 7.1748H62.6002V13.418H63.642V7.1748Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8881 7.17529H79.0775H79.9298H80.1192L82.9604 11.7434V7.17529H84.0021V13.4185H82.9604L79.9298 8.54575V13.4185H78.8881V7.17529Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5741 9.98608H49.4265L49.3982 10.8743H46.5741V9.98608Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5329 13.5668C48.4121 13.5834 49.9793 12.281 49.666 10.0192C49.666 10.0082 49.6659 9.99718 49.6658 9.98618H48.8327C48.8395 10.0806 48.8418 10.1778 48.8396 10.2777C48.8415 11.8931 47.8947 12.6508 46.5612 12.6508C45.2277 12.6508 44.1466 11.5883 44.1466 10.2777C44.1466 8.96698 45.2277 7.90448 46.5612 7.90448C47.2284 7.90448 47.8065 8.12874 48.2137 8.53784L48.8663 7.89635C48.3111 7.32026 47.4991 6.98853 46.5329 6.98853C44.6847 6.98853 43.1865 8.46111 43.1865 10.2777C43.1865 12.0941 44.6847 13.5642 46.5329 13.5668Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.649 18.3569H102.281V26.3762H107.649C107.649 26.3762 110.741 25.8587 110.741 22.3665C110.741 18.8744 107.649 18.3569 107.649 18.3569ZM106.967 20.2967H103.322V24.6001H106.967C106.967 24.6001 108.625 24.6001 108.625 22.4484C108.625 20.2967 106.967 20.2967 106.967 20.2967Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.701 18.3569H101.807V31.4024H103.701V18.3569Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.742 18.3569H111.848V31.4024H113.742V18.3569Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.801 22.7368C116.151 22.7368 115.269 24.5276 115.269 24.5276L116.846 25.445C116.846 25.445 117.227 24.5276 118.952 24.5276C120.207 24.5276 120.626 25.4603 120.761 25.968V26.3512C120.211 26.0881 119.02 25.6737 117.321 25.9224C115.014 26.2597 115.061 28.3113 115.067 28.6351C115.068 28.6485 115.068 28.6589 115.068 28.6662C115.068 28.8489 115.07 31.5585 118.088 31.3731C119.406 31.2921 120.239 30.8935 120.761 30.47V31.3985H122.655V25.736V25.7251C122.655 24.9722 122.094 22.7368 118.801 22.7368ZM116.85 28.725C116.977 26.708 120.626 27.6757 120.626 27.6757C120.626 27.6757 120.675 27.8889 120.675 28.3437C120.351 29.7734 116.723 30.742 116.85 28.725Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.157 28.6943L124.727 23.0161H122.833L126.21 30.9075L124.442 35.0366H126.336L131.461 23.0612H129.567L127.157 28.6943Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5626 22.7371C96.7385 22.7371 97.5683 26.0661 97.5683 26.0661L91.5782 28.5019C91.5782 28.5019 91.9652 29.8493 93.7662 29.8583C95.1762 29.8654 95.9729 28.6283 95.9729 28.6283L97.4927 29.6411C97.4927 29.6411 96.2659 31.5927 93.7542 31.5927C90.6676 31.5927 89.308 28.9371 89.308 27.2124C89.308 25.5507 90.3872 22.7371 93.5626 22.7371ZM93.3799 24.4558C94.5354 24.2477 95.2896 25.376 95.2896 25.376L91.2425 27.0012C91.2425 27.0012 90.9349 24.8959 93.3799 24.4558Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4708 18.3569H86.467V31.375H88.4708V18.3569Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2571 23.8324V23.0199L85.1095 23.0357V31.2497C85.1095 33.3483 83.8396 35.5637 80.8499 35.5637C77.8604 35.5637 76.8948 32.9574 76.8948 32.9574L78.596 32.2534C78.596 32.2534 79.1149 33.8597 80.9384 33.8597C83.015 33.8597 83.2574 32.0008 83.2574 31.3646V30.4731C83.2574 30.4731 82.5389 31.5796 80.7542 31.5796C78.8192 31.5796 76.5199 29.9485 76.5199 27.1677C76.5199 24.3868 78.685 22.7963 80.7766 22.7384C82.4519 22.692 83.2571 23.8324 83.2571 23.8324ZM83.3583 27.1911C83.3583 28.6929 82.2632 29.9105 80.9123 29.9105C79.5615 29.9105 78.4665 28.6929 78.4665 27.1911C78.4665 25.6892 79.5615 24.4718 80.9123 24.4718C82.2632 24.4718 83.3583 25.6892 83.3583 27.1911Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6903 27.163C75.6903 29.6074 73.6718 31.5891 71.1817 31.5891C68.6916 31.5891 66.6731 29.6074 66.6731 27.163C66.6731 24.7184 68.6916 22.7368 71.1817 22.7368C73.6718 22.7368 75.6903 24.7184 75.6903 27.163ZM73.6865 27.163C73.6865 28.6488 72.5519 29.8533 71.1522 29.8533C69.7525 29.8533 68.618 28.6488 68.618 27.163C68.618 25.6771 69.7525 24.4725 71.1522 24.4725C72.5519 24.4725 73.6865 25.6771 73.6865 27.163Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9354 27.1632C65.9354 29.6076 63.9168 31.5893 61.4267 31.5893C58.9368 31.5893 56.9181 29.6076 56.9181 27.1632C56.9181 24.7187 58.9368 22.7371 61.4267 22.7371C63.9168 22.7371 65.9354 24.7187 65.9354 27.1632ZM63.9315 27.1632C63.9315 28.6491 62.7969 29.8535 61.3973 29.8535C59.9977 29.8535 58.863 28.6491 58.863 27.1632C58.863 25.6773 59.9977 24.4728 61.3973 24.4728C62.7969 24.4728 63.9315 25.6773 63.9315 27.1632Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7842 24.1399H55.7368L55.6779 25.9914H49.7842V24.1399Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6963 31.6035C53.6178 31.6381 56.8888 28.9234 56.2347 24.2086C56.2347 24.1856 56.2346 24.1626 56.2344 24.1398H54.4956C54.5098 24.3366 54.5147 24.5392 54.51 24.7472C54.5141 28.1147 52.5382 29.6942 49.7552 29.6942C46.9723 29.6942 44.7162 27.4793 44.7162 24.7472C44.7162 22.0152 46.9723 19.8004 49.7552 19.8004C51.1475 19.8004 52.3542 20.2679 53.2038 21.1207L54.5659 19.7835C53.4074 18.5826 51.7124 17.8911 49.6963 17.8911C45.8391 17.8911 42.7123 20.9607 42.7123 24.7472C42.7123 28.5339 45.8391 31.5981 49.6963 31.6035Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3028 17.8649C33.3126 18.9896 33.3126 21.8448 31.3028 22.9696L14.7875 32.2122C12.803 33.3229 10.341 31.9097 10.341 29.6599V11.1749C10.341 8.92507 12.8029 7.51185 14.7874 8.62243L31.3028 17.8649Z",
    fill: "url(#paint0_linear_69_2593)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_2593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 23,
    height: 25
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3028 17.8649C33.3126 18.9896 33.3126 21.8448 31.3028 22.9696L14.7875 32.2122C12.803 33.3229 10.341 31.9097 10.341 29.6599V11.1749C10.341 8.92507 12.8029 7.51185 14.7874 8.62243L31.3028 17.8649Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_2593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3231 7.25977L23.5615 20.2061L10.152 33.6639L10.3231 7.25977Z",
    fill: "url(#paint1_linear_69_2593)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60002 4.59448L23.5593 20.2096L28.3041 15.7559L7.60002 4.59448Z",
    fill: "url(#paint2_linear_69_2593)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5611 20.2061L30.825 27.4099L9.12469 34.6139L23.5611 20.2061Z",
    fill: "url(#paint3_linear_69_2593)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 139.826,
    height: 40,
    rx: 5.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_2593",
    x1: 35.8637,
    y1: 14.8594,
    x2: 25.9321,
    y2: 14.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_69_2593",
    x1: 11.4522,
    y1: 31.8497,
    x2: 21.2751,
    y2: 30.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_69_2593",
    x1: 5.22346,
    y1: 12.6943,
    x2: 14.7639,
    y2: 25.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_69_2593",
    x1: 17.2865,
    y1: 18.0795,
    x2: 9.16352,
    y2: 32.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2414E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02554"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_2593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.826,
    height: 41,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.47266285af872736472072636400967c.svg";
export { ForwardRef as ReactComponent };